var React = require('react');

function UploadNew (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M11.7 10a.998.998 0 0 1 1.521-.093l3.536 3.536a1 1 0 1 1-1.414 1.414L13.5 13.014V19.6a1 1 0 1 1-2 0v-6.572l-1.829 1.829a1 1 0 0 1-1.414-1.414L11.7 9.999zM8 5h9a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2z","id":"a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("mask",{"id":"b","fill":"#fff","key":0},React.createElement("use",{"xlinkHref":"#a"})),React.createElement("g",{"mask":"url(#b)","fill":"currentColor","key":1},[React.createElement("path",{"d":"M0 0h25v25H0z","key":0}),React.createElement("path",{"d":"M0 0h25v25H0z","key":1})])])]);
}

UploadNew.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = UploadNew;

UploadNew.default = UploadNew;
